import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager'

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const ROUTE_TO_ABMMODELOS = "ROUTE_TO_ABMMODELOS";
export const INITIAL_STATE = "INITIAL_STATE";
export const MODELOSCONTABLES_MOSTRAR_SPINNER = "MODELOSCONTABLES_MOSTRAR_SPINNER";
export const MODELOSCONTABLES_CARGAR_PERMISOS_USUARIO = "MODELOSCONTABLES_CARGAR_PERMISOS_USUARIO";
export const MODELOSCONTABLES_POBLAR_GRILLA = "MODELOSCONTABLES_POBLAR_GRILLA";
export const MODELOSCONTABLES_CAMBIAR_ORDEN_GRILLA = "MODELOSCONTABLES_CAMBIAR_ORDEN_GRILLA";
export const MODELOSCONTABLES_MOSTRAR_ACTIVOS_GRILLA = "MODELOSCONTABLES_MOSTRAR_ACTIVOS_GRILLA";
export const MODELOSCONTABLES_FILTRAR_MODELOS = "MODELOSCONTABLES_FILTRAR_MODELOS";
export const MODELOSCONTABLES_PRIMERA_CARGA = "MODELOSCONTABLES_PRIMERA_CARGA";

//Definicion de variables globales
let _dispatch = null;


/* ModelosContables.jsx */
export function obtenerInformacionPantalla(currentScope) {
    LogHelper.In(obtenerInformacionPantalla.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _dispatch({ type: MODELOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargarInformacionPantalla(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

    function _cargarInformacionPantalla(data) {
        let permisos = [];

        data.CONTABILIDAD.forEach(p => { permisos[p.Codigo_Funcion] = true  });

        _dispatch({ type: MODELOSCONTABLES_CARGAR_PERMISOS_USUARIO, permisos });

        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_BUSQUEDA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.Execute((data) => _obtencionDatosGrillaPantallaPrincipal(data), _obtencionDatosGrillaPantallaPrincipal(permisos), null, "CONTABILIDAD");   
    }

    function _obtencionDatosGrillaPantallaPrincipal(data) {
        let datosGrilla = [];
        let datosGrillaActivos = [];

        if(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_BUSQUEDA) {
            datosGrilla = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_BUSQUEDA).Recordset0.Rows;
            //Por default está el check de registros activos activado.
            datosGrillaActivos = datosGrilla.filter(reg => {return reg.Activo});

            _dispatch({ type: MODELOSCONTABLES_PRIMERA_CARGA, valor: false });
            _dispatch({ type: MODELOSCONTABLES_POBLAR_GRILLA, datosGrilla, datosGrillaActivos });
            _dispatch({ type: MODELOSCONTABLES_MOSTRAR_SPINNER, valor: false });
        } else {
            //En el caso de salir por "error" y no tener los permisos suficientes para consultar la pantalla, muestro el mensaje en pantalla de que no tiene permisos.
            if(!data.Consulta) {
                _dispatch({ type: MODELOSCONTABLES_PRIMERA_CARGA, valor: false });
                _dispatch({ type: MODELOSCONTABLES_MOSTRAR_SPINNER, valor: false });
            }
        }
    }


/* ModelosContables.jsx */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    }
}


/* SeccionSuperior/SeccionSuperior.jsx */
export function routeToABMModelos(id, dispatch) {
    LogHelper.In(routeToABMModelos.name, id, dispatch);

    return (dispatch) => {
        _routing(id, ROUTE_TO_ABMMODELOS, dispatch);
    }
}

    function _routing(id, option, dispatch) {
        LogHelper.In(_routing.name, id, option, dispatch);

        if (id) {
            id = JSON.stringify(id);
        }

        const redirectLocation = ProcessManager.GetNextStep("ModelosContables", option, id) + "/" + id;

        _dispatch({ type: ROUTE_TO_ABMMODELOS, data: redirectLocation })
    }


/* SeccionGrilla/CabeceraGrilla.jsx */
export function cambiarOrden(columna, valor) {
    LogHelper.In(cambiarOrden.name, columna, valor);

    return (dispatch) => {
        _dispatch({ type: MODELOSCONTABLES_CAMBIAR_ORDEN_GRILLA, columna, valor });
    }
}


/* SeccionSuperior/SeccionSuperior.jsx */
export function mostrarActivos(valor) {
    LogHelper.In(mostrarActivos.name, valor);

    return (dispatch, getState) => {
        let datosGrilla = getState().modelosContables.datosGrilla;
        let buscadorActivo = getState().modelosContables.inputBuscador;

        datosGrilla = valor ? 
                        datosGrilla.filter(registro => {return registro.Activo})
                    :
                        datosGrilla;

        if(buscadorActivo) {
            datosGrilla = filtrarModelos(datosGrilla, buscadorActivo);
        }

        _dispatch({ type: MODELOSCONTABLES_MOSTRAR_ACTIVOS_GRILLA, valor, datosGrilla });
    }
}


/* SeccionSuperior/Buscador.jsx */
export function buscarModelos(valorInput) {
    LogHelper.In(buscarModelos.name, valorInput);
    let modelosFiltradosBuscador = [];

    return (dispatch, getState) => {
        let modelosActivos = getState().modelosContables.checkRegistrosActivos;
        let modelos = getState().modelosContables.datosGrilla;

        modelos = modelosActivos ? modelos.filter(m => m.Activo) : modelos;

        modelosFiltradosBuscador = filtrarModelos(modelos, valorInput);

        _dispatch({ type: MODELOSCONTABLES_FILTRAR_MODELOS, modelosFiltradosBuscador, valorInput });
    }
}



/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++FUNCIONES AUXILIARES++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
function filtrarModelos(modelos, valorInput) {
    let modelosFiltradosBuscador = [];

    if(valorInput){
        let modelosFiltradosCodigo = modelos.filter( function(m) {
            let modelosFiltrados = m["Codigo"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosDescripcion = modelos.filter( function(m) {
            let modelosFiltrados = m["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosMarca = modelos.filter( function(m) {
            let marca = m["Marca"] || "AD17"
            let modelosFiltrados = marca.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosTipoMovimiento = modelos.filter( function(m) {
            let modelosFiltrados = m["Movimientos"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let modelosMergeados = [...modelosFiltradosCodigo, ...modelosFiltradosDescripcion, ...modelosFiltradosMarca, ...modelosFiltradosTipoMovimiento];

         modelosFiltradosBuscador = [... new Set(modelosMergeados)];
    }
    else {
        modelosFiltradosBuscador = modelos;
    }

    return modelosFiltradosBuscador;
}